<div class="p-shadow-3 p-text-center container">
  <h1>Üzgünüz aradığınız sayfa yok</h1>
  <img src="../../../assets/images/404.png" />
  <div class="p-p-3">
    <h4>{{ counter }} içerisinde anasayfaya yönlendirileceksiniz.</h4>
    <button (click)="goHomePage()" pButton class="p-button-secondary" label="Ana Sayfa'ya Git"></button>
  </div>
</div>
